import { Configurable, createSiteConfig } from "@crystal/config";
import * as index from "./sites/index.js";
const defaultMfSiteConfig = Configurable.props({
  isSelectAllEnabled: false,
  selectAllScenarios: ["registration"]
});
function getMfSiteConfig() {
  return createSiteConfig(
    index,
    defaultMfSiteConfig
  );
}
export {
  getMfSiteConfig
};
//# sourceMappingURL=site-config.js.map
